module.exports = new __parcel__URL__("Brainstorming Hover.e1c833f7.svg").toString();